<template>
  <div class="menuBody" style="width:1600px">
    <paymentTree @paymentTree="getMsgFormSon"  />
        <PaymentPrintDialog :param="diaLogData" ref="PaymentPrintDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                账单列表  <!--  催缴通知单打印  -->
            </div>
              <div style="float:left;">
                <el-button type="primary" size="small" plain   style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cp:callNotice:printing'" @click="CashPledge()">催缴单打印</el-button>
            </div>
  <el-table  :data="tableData" v-loading="loading"  style="float:right;margin-top:30px"  tooltip-effect="light" 
    :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"
           height="400px"   row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column label="序号" type="index" width="60"></el-table-column>
    <el-table-column prop="feeName" label="项目" ></el-table-column>
    <el-table-column prop="zjCny" label="应收年月" ></el-table-column>
    <el-table-column prop="zjJe" label="应收金额" ></el-table-column>
    <el-table-column prop="subjectsName" label="对应科目" ></el-table-column>
    <el-table-column prop="ext2" label="计费单价" ></el-table-column>
    <el-table-column prop="ext1" label="计费方式" >
 <template slot-scope="scope">
        <el-tag type="success" v-if="scope.row.ext1=='0'" >按月收费</el-tag>
        <el-tag v-if="scope.row.ext1=='1'" >单价*面积</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="zjRemarks" label="账单备注" ></el-table-column>
  </el-table>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import PaymentPrintDialog from "../common/PaymentPrintDialog";
import paymentTree from "../common/paymentTree.vue";

export default {
  name: "Receivable",
  components: {PaymentPrintDialog,paymentTree},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillDateVal:"",
         props: { multiple: true },
      tableData: [],
      options: [],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      taxRateval:"",
      roomId:"",
      customerId:"",
      projectId:"",
      foorId:"",
      project:"",
      JsonArr:[],
      roomIdArr:[],
      customerName:"",
    }
  },
  methods: {
      CashPledge(){
        
        let address = this.project.label + this.AllData.roomName
          this.$refs.PaymentPrintDialog.dialogVisible = true; 
          this.$refs.PaymentPrintDialog.title = "缴费通知单";
          this.$refs.PaymentPrintDialog.item = this.project.label;
          this.$refs.PaymentPrintDialog.customerName = this.customerName;
          this.$refs.PaymentPrintDialog.address = address;
          this.$refs.PaymentPrintDialog.projectId =this.projectId;
          this.$refs.PaymentPrintDialog.roomId =this.roomId;
          this.$refs.PaymentPrintDialog.JsonArr =this.JsonArr;
      },
                  unique(arr){            
        for(var i=0; i<arr.length; i++){
            for(var j=i+1; j<arr.length; j++){
                if(arr[i]==arr[j]){         //第一个等同于第二个，splice方法删除第二个
                    arr.splice(j,1);
                    j--;
                }
            }
        }
return arr;
},
    getMsgFormSon(data){
      if(data.children == null && data.orgId == null){
        this.foorId = data.id
      }
          if(data.roomId){
          this.roomId = data.roomId
          this.customerId = data.customerId
          this.AllData = data
          this.customerName = data.customerName
          this.ShareList()
        }else if(data.orgId != null){
          this.project = data
          this.projectId = data.id
        }
    },
    ShareList(){
      this.JsonArr = []
          let PageSize = {
            "customerId":this.customerId,// 业主ID
            "projectId":this.projectId,
            "foorId":this.foorId,
      }
        this.$http.post(this.$requestUrl.POST_INFORM_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 == data.code) {
            if(data.data != null){
            for(let val of data.data){

                this.JsonArr.push(val.id)
                this.unique(this.JsonArr)
              }
          this.tableData = data.data
            } 
           this.loading = false
          } else {
            this.$message.error(data.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    handleSizeChange(val) {
        this.pagesize  = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
  },
  mounted() {}
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}

</style>